export const ConnectorType = {
  integration: "Integration",
  resource: "Resource",
  cloud: "Cloud",
};
